module.exports = __webpack_public_path__ + "img/RBS.ab310559.png";